// @flow

import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Loader from './Loader';

import typeof TTheme from '../theme';

type TP = {
  disabled?: boolean,
  theme: TTheme,
  variant: 'inverse' | 'secondary' | 'standard' | void,
};

const DANGER = 'danger';
const DEFAULT = 'default';
const INVERSE = 'inverse';
const SECONDARY = 'secondary';

const dangerHover = theme => `
  background-color: ${theme.colors.tomatoDark};
  color: ${theme.colors.white};
`;
const inverseHover = theme => `
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
`;
const secondaryHover = theme => `
  background-color: black;
`;
const standardHover = theme => `
  background-color: ${theme.colors.primaryHover};
`;

const _Loader = styled(Loader)`
  color: inherit;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -25%);
`;

const Hidden = styled.div`opacity: 0;`;

const _Button = ({
  children,
  submitting,
  ...props
}: {
  children: React.Node,
  submitting?: boolean,
}) => (
  <button {...props} disabled={submitting}>
    {submitting
      ? [
          <_Loader key="loader" size="tiny" />,
          <Hidden key="children">{children}</Hidden>,
        ]
      : children}
  </button>
);

const Button = styled(_Button)`
  background-color: ${({ theme, variant }: TP) => {
    switch (variant) {
      case DANGER:
        return theme.colors.tomato;
      case INVERSE:
        return theme.colors.white;
      case SECONDARY:
        return theme.colors.slateGrey;
      default:
        return theme.colors.primary;
    }
  }};
  border-radius: 20px;
  border: ${({ theme, variant }: TP) => {
    switch (variant) {
      case INVERSE:
        return '1px solid ' + theme.colors.primary;
      case DANGER:
      case SECONDARY:
      default:
        return 0;
    }
  }};
  color: ${({ theme, variant }: TP) => {
    switch (variant) {
      case DANGER:
        return theme.colors.white;
      case INVERSE:
        return theme.colors.primary;
      case SECONDARY:
        return theme.colors.white;
      default:
        return theme.colors.white;
    }
  }};
  cursor: ${({ disabled }: TP) => (disabled ? 'default;' : 'pointer;')};
  display: block;
  font-size: ${({ theme }: TP) => theme.typography.size.standard};
  font-weight: bold;
  line-height: 1;
  opacity: ${({ disabled }: TP) => (disabled ? '0.7;' : '1.0;')};
  padding: 10px 30px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease-in;
  &:focus {
    outline: 0;
  }
  &:focus,
  &:hover {
    ${({ disabled, theme, variant }: TP) => {
      if (disabled) {
        return;
      }
      switch (variant) {
        case DANGER:
          return dangerHover(theme);
        case INVERSE:
          return inverseHover(theme);
        case SECONDARY:
          return secondaryHover(theme);
        default:
          return standardHover(theme);
      }
    }};
  }
`;

export const LinkStyleButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme, variant }: TP) => {
    switch (variant) {
      case DANGER:
        return theme.colors.tomato;
      case DEFAULT:
      default:
        return theme.colors.primary;
    }
  }};
  cursor: pointer;
  font-size: ${({ theme }: TP) => theme.typography.size.standard};
  &:focus {
    outline: 0;
  }
`;

export const LinkButton = Button.withComponent(Link);
export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js